export enum PosterEditorItemAdjustmentOptions {
  NONE = 'none',
  TINT = 'tint',
  BRIGHTNESS = 'brightness',
  CONTRAST = 'contrast',
  VIBRANCE = 'vibrance',
  SATURATION = 'saturation',
  GAMMA = 'gamma',
  MULTIPLY = 'multiply',
}
